import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useCreateEmailDraftMutation } from "../../../services/draftsService";
import { EmailTemplateForm } from "./EmailTemplateForm";

export function EmailTemplateAddDialog({ title, open, onClose, onSuccessAdd, draftType }) {
    const { t } = useTranslation();
    const { mutate: createEmailDraft } = useCreateEmailDraftMutation({
        onSuccess: () => {
            toast.success(t("drafts.saveTemplate"));
            onClose();
            onSuccessAdd?.();
        },
    });

    const handleSubmit = (data) => {
        createEmailDraft({
            nr: data.templateNumber,
            name: data.templateName,
            description: data.templateDescription,
            subject: data.subject,
            body: data.body,
            language: data.templateLanguage,
            active: data.active === "true",
            draft_notification: data.draftNotification
        });
    };

    const handleError = (errors) => {
        console.error("Form errors:", errors);
        toast.error("Proszę wypełnić wszystkie wymagane pola");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", position: "relative" }}>
                {title ? title.toUpperCase() : t("drafts.emailTemplates.addTemplate").toUpperCase()}
                <IconButton
                    aria-label={t("close") || "Close"}
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <EmailTemplateForm
                    onSubmit={handleSubmit}
                    onError={handleError}
                    submitBtnText={t("drafts.saveTemplate")}
                    draftType={draftType}
                />
            </DialogContent>
        </Dialog>
    );
}
